<template>
  <div class="main">
    <div class="top_back">
      <DivTop />
    </div>
    <vue-particles
      color="#00aeff"
      :particleOpacity="0.7"
      :particleOpacityRandom="true"
      :particlesNumber="140"
      shapeType="circle"
      :particleSize="4"
      linesColor="#8EB5C9"
      :linesWidth="1"
      :lineLinked="false"
      :lineOpacity="0.6"
      :linesDistance="120"
      :moveSpeed="1"
      :hoverEffect="false"
      hoverMode="grab"
      :clickEffect="false"
      clickMode="push"
  >

      
    </vue-particles>
    <div class="txts">
      <span>Hello!</span>
      <div>
        <span>欢迎登陆</span>
        <span>金飞鹰智能科技内网</span>
      </div>
    </div>
    <div class="login_box">
        <div class="forms">
            <input type="text" v-model="username">
            <input type="password" v-model="pasw">
            <div class="btns_click">
               <input type="checkbox" name="1" id="" v-model="check">
               <span>记住密码</span>
               <div>登 陆</div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      username:'',
      pasw:'',
      check:true
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  width: 100%;
  // background: #070D2A;
  height: 100%;
  overflow: hidden;
  position: relative;
  .top_back{
    width: 100%;
    position: relative;
  }
  >div:nth-child(2){
    background: #070D2A;
    height: 100vh;
  } 
  .login_box{
    width: 60rem;
    height: 36rem;
    background: rgba(205,224,238,0.1);
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%,-50%);
    border-radius: 0.8rem;
    .forms{
      padding: 7rem 5rem;
      box-sizing: border-box;
      >input{
        width: 100%;
        height: 5rem;
        background: rgba(247,247,250,0.1);
        outline: none;
        border: 0;
        border-radius: 0.6rem;
        margin-bottom: 3rem;
        padding: 0 2rem;
        color: #fff;
        font-size: 1.6rem;
      }
      .btns_click{
        display: flex;
        align-items: center;
        input{
          width: 1.6rem;
          height: 1.6rem;
        }
        span{
          margin-left: 1rem;
          color: #fff;
          font-size: 1.6rem;
        }
        >div{
          flex: 1;
          margin-left: 4rem;
          height: 5rem;
          // background-image: linear-gradient(to bottom, #FF9900, #FCC62C);
          background-image: linear-gradient(90deg, #FCC62C, #FF9900);
          color: #fff;
          font-size: 2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0.8rem;
          margin-top: 1rem;
          cursor: pointer;
        }
      }
    }
  }
  .txts{
    position: absolute;
    top: 24%;
    left: 50%;
    transform: translate(-45%,-50%);
    >span{
      color: #fff;
      font-size: 5rem;
      text-align: center;
      display: block;
    }
    div{
      margin-top: 0.7rem;
      display: flex;
      align-items: center;
      span{
        color: #fff;
        font-size: 1.6rem;
        &:nth-child(2){
          color: #246DEB;
        }
      }
    }
  }
}
</style>